import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const Container = styled.div`
    min-height: 100vh;
    background-color: var(--background, #ffffff);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
`

export const IconWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 3rem;
    height: 3rem;
    background-color: rgba(239, 68, 68, 0.1); /* bg-destructive/10 */
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
`

export const ErrorIcon = styled.div`
    height: 1.5rem;
    width: 1.5rem;
    color: #ef4444;
`

export const ErrorMessageBox = styled.div`
    padding: 0.75rem;
    background-color: #f3f4f6;
    border-radius: 0.375rem;
`

export const ErrorMessage = styled.p`
    ${getFontStyle('p02Regular')} /* 14px, 400 weight - matches 0.875rem */
    font-family: ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    color: #6b7280;
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 0.5rem;
`

export const ButtonWrapper = styled.div`
    flex: 1;
`

export const ErrorContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`
